import { render } from "./profileOne.vue?vue&type=template&id=2b5c36d0"
import script from "./profileOne.vue?vue&type=script&lang=js"
export * from "./profileOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__